export const yclientsCodes = {
    msk: {
        serviceType: "msk",
        ym: "zapiskosmetologmsk",
        routes: [
            { coordinates: [55.74240055227125, 37.629249528082795] },
            { coordinates: [55.728998376950045, 37.622801086137166] },
            { coordinates: [55.72686359141693, 37.624820652910294] },
        ],
    },
    arbat: {
        serviceType: "arbat",
        ym: "zapiskosmetologarbat",
        routes: [
            { coordinates: [55.75239336382937, 37.60334197075219] },
            { coordinates: [55.74791675883498, 37.583713473178555] },
        ],
    },
    "moskva-arbatskaya": {
        serviceType: "arbat",
        ym: "zapiskosmetologarbat",
        routes: [
            { coordinates: [55.75239336382937, 37.60334197075219] },
            { coordinates: [55.74791675883498, 37.583713473178555] },
        ],
    },
    spb: {
        serviceType: "spb",
        ym: "zapiskosmetologspb",
        routes: [
            { coordinates: [59.92082212681292, 30.35496667872799] },
            { coordinates: [59.92214128243348, 30.336002039117044] },
            { coordinates: [59.92069027090646, 30.32954398987001] },
        ],
    },
    spb2: {
        serviceType: "spb2",
        ym: "zapiskosmetologspb2",
        routes: [
        ],
    },
    kgd: {
        serviceType: "kgd",
        ym: "zapiskosmetologkgd",
        routes: [
            { coordinates: [54.72080187879709, 20.5164027493515] },
            { coordinates: [54.72127930746956, 20.514613715938577] },
            { coordinates: [54.72033111748563, 20.513247258774037] },
        ],
    },
    ekb: {
        serviceType: "ekb",
        ym: "zapiskosmetologekb",
        routes: [
            { coordinates: [56.836268904323276, 60.59967207261656] },
            { coordinates: [56.82729159078693, 60.602086635480475] },
            { coordinates: [56.842881362414666, 60.632605699825376] },
        ],
    },
    kzn: {
        serviceType: "kzn",
        ym: "zapiskosmetologkzn",
        routes: [
            { coordinates: [55.78520406883622, 49.12594698812264] },
            { coordinates: [55.777582140641144, 49.14114750062091] },
        ],
    },
    nsk: {
        serviceType: "nsk",
        ym: "zapiskosmetolognsk",
        routes: [
            { coordinates: [55.04230738524153, 82.91668180274112] },
            { coordinates: [55.042842090331725, 82.92049883109412] },
        ],
    },
    online: {
        serviceType: "online",
        ym: "SKIN_REQUEST",
    },
    nino: {
        serviceType: "nino",
        ym: "zapiskosmetolognino",
    },
    krsk: {
        serviceType: "krsk",
        ym: "zapiskosmetologkrsk",
    },
    ufa: {
        serviceType: "ufa",
        ym: "zapiskosmetologufa",
    },
    "moskva-m-tsvetnoy-bulvar": {
        serviceType: "moskva-m-tsvetnoy-bulvar",
        ym: "zapiskosmetologmoskva-m-tsvetnoy-bulvar",
    },
};

let configurationPromise;

export async function loadYclientsCodes() {
    if (!configurationPromise) {
        configurationPromise = (async () => {
            const response = await fetch(`${window.location.origin}/ajax/appYclients.php`, {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
                body: "action=getBranchConfiguration",
                cache: "no-store",
            });
            if (!response.ok) throw new Error("Настройки записи временно недоступны");
            const data = await response.json();
            if (!data.success || !data.branches || !Object.keys(data.branches).length) {
                throw new Error(data.message || "Настройки записи временно недоступны");
            }

            const configured = {};
            Object.entries(data.branches).forEach(([code, branch]) => {
                configured[code] = {
                    ...yclientsCodes[code],
                    serviceType: code,
                    companyId: branch.companyId,
                    serviceId: branch.serviceId,
                    waitingEmployeeId: branch.waitingEmployeeId,
                };
            });
            if (configured.arbat) configured["moskva-arbatskaya"] = configured.arbat;
            Object.keys(yclientsCodes).forEach((code) => { delete yclientsCodes[code]; });
            Object.assign(yclientsCodes, configured);
            return yclientsCodes;
        })().catch((error) => {
            configurationPromise = null;
            throw error;
        });
    }
    return configurationPromise;
}
